import { T } from '@tolgee/react';
import { Card, Col, Row } from 'antd';
import { LuClipboardPen, LuTimer } from 'react-icons/lu';
import { RiSlideshow2Line } from 'react-icons/ri';
import styled from 'styled-components';

import theme from '../../../../assets/theme';
import { useDynamicLessonStateContext } from '../../../../hooks/useCreateLessonState';
import { useMetrics } from '../../../../hooks/useMetrics';

export function GetStartedCards() {
  const dispatchAndSync = useDynamicLessonStateContext(
    context => context.dispatchAndSync,
  );
  const metrics = useMetrics();
  const cards = [
    {
      onClick: () => {
        metrics.logEvent('CreatePage.GetStarted.ImportSlides');
        dispatchAndSync({
          type: 'SET_MAIN_LESSON_CATEGORY',
          payload: 'upload',
        });
      },
      key: 'import-slides',
      title: (
        <T
          keyName="IntentRefinement.GetStarted.ImportSlides.Title"
          defaultValue="Import My Slides"
        />
      ),
      subtitle: (
        <T
          keyName="IntentRefinement.GetStarted.ImportSlides.Subtitle"
          defaultValue="Add activities to your slides"
        />
      ),
      icon: (
        <IconWrapper size={30} color="#53998066">
          {/* @ts-expect-error react-icons type mismatch */}
          <RiSlideshow2Line size={30} color="#539980" />
        </IconWrapper>
      ),
      color: '#539980',
    },
    {
      key: 'test-prep',
      title: (
        <T
          keyName="IntentRefinement.GetStarted.TestPrep.Title"
          defaultValue="Test Prep"
        />
      ),
      subtitle: (
        <T
          keyName="IntentRefinement.GetStarted.TestPrep.Subtitle"
          defaultValue="Prepare for standardized testing"
        />
      ),
      icon: (
        <IconWrapper size={30} color="#33A0DD26">
          {/* @ts-expect-error react-icons type mismatch */}
          <LuClipboardPen size={30} color="#33A0DD" />
        </IconWrapper>
      ),
      onClick: () => {
        metrics.logEvent('CreatePage.GetStarted.TestPrep');
        dispatchAndSync({
          type: 'SET_MAIN_LESSON_CATEGORY',
          payload: 'test_prep',
        });
      },
      color: '#539980',
    },
    {
      key: 'quick-writes',
      title: (
        <T
          keyName="IntentRefinement.GetStarted.QuickWrites.Title"
          defaultValue="Quick Writes"
        />
      ),
      subtitle: (
        <T
          keyName="IntentRefinement.GetStarted.QuickWrites.Subtitle"
          defaultValue="5 - 20 minute activities"
        />
      ),
      icon: (
        <IconWrapper size={30} color="#A97CFF26">
          {/* @ts-expect-error react-icons type mismatch */}
          <LuTimer size={30} color="#A97CFF" />
        </IconWrapper>
      ),
      onClick: () => {
        metrics.logEvent('CreatePage.GetStarted.QuickWrites');
        dispatchAndSync({
          type: 'SET_MAIN_LESSON_CATEGORY',
          payload: 'writing_skills',
        });
      },
      color: '#A97CFF26',
    },
  ];
  return (
    <Row gutter={[16, 16]} style={{ width: '100%' }}>
      {cards.map(card => (
        <Col xs={24} md={8} key={card.key}>
          <GetStartedCard {...card} />
        </Col>
      ))}
    </Row>
  );
}

function GetStartedCard({
  title,
  subtitle,
  icon,
  onClick,
}: //   color,
{
  title: React.ReactNode;
  subtitle: React.ReactNode;
  icon: React.ReactNode;
  onClick: () => void;
  //   color: string;
}) {
  return (
    <Card
      onClick={onClick}
      size="small"
      style={{
        cursor: 'pointer',
        padding: '8px 12px',
        background: '#FFFFFFAA',
        borderRadius: '10px',
        borderStyle: 'dashed',
        borderColor: '#D9D9D9',
        borderWidth: '1px',
      }}
      bodyStyle={{ padding: '0px' }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        {icon}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
            alignItems: 'flex-start',
          }}
        >
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </div>
      </div>
    </Card>
  );
}

const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  margin-top: 0px;
  text-align: center;
  user-select: none;
`;

const Subtitle = styled.p`
  font-size: 12px;
  color: #828282;
  color: ${theme.colors.subtitleGrey};
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
  user-select: none;
`;

function IconWrapper({
  children,
  color,
  size = 26,
}: {
  children: React.ReactNode;
  size?: number;
  color: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: color,
        opacity: '0.6',
        borderRadius: '5px',
        padding: '5px',
        gap: '10px',
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      {children}
    </div>
  );
}
